
import { useEffect, useState } from "react";

const useDebounce = (initialValue = "", delay) => {
  const [debouncedValue, setDebouncedValue] = useState(initialValue);
  useEffect(
    () => {
      // Update debounced value after delay
      const handler = setTimeout(() => {
        setDebouncedValue(initialValue);
      }, delay);
      // Cancel the timeout if value changes (also on delay change or unmount)
      // This is how we prevent debounced value from updating if value is changed ...
      // .. within the delay period. Timeout gets cleared and restarted.
      return () => {
        clearTimeout(handler);
      };
    },
    [initialValue, delay] // Only re-call effect if value or delay changes
  );
  return debouncedValue;
};

export default useDebounce;